import { render, staticRenderFns } from "./FriendItemsList.vue?vue&type=template&id=1e9fb602&"
import script from "./FriendItemsList.vue?vue&type=script&lang=js&"
export * from "./FriendItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports